module.exports = __webpack_public_path__ + "assets/img/202110-3W.c84edc49.png";